import { waitForValue } from 'shared/utils/common'
import { isNilOrEmpty } from 'shared/utils/ramda'

export const getSyneriseClientUUID = (): string => {
  if (typeof window === 'undefined') return ''

  return (
    window.SyneriseTC?.uuid ??
    window.SR?.client?.getCurrentClient?.()?._result?.uuid ??
    ''
  )
}

export const waitForSyneriseClientUUID = async (): Promise<
  string | undefined
> => {
  const syneriseClientUUID = await waitForValue<string>(getSyneriseClientUUID)

  return isNilOrEmpty(syneriseClientUUID)
    ? undefined
    : (syneriseClientUUID as string)
}
